import { render, staticRenderFns } from "./CreateModelsForm.vue?vue&type=template&id=60743163&"
import script from "./CreateModelsForm.vue?vue&type=script&lang=js&"
export * from "./CreateModelsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports